import { PaymentsProvider } from '@zorro/clients';
import { useEmployerFeatureFlag } from '@zorro/web/ui-utils';

export function usePaymentsProvider(employerId: string) {
  const { isOn: isLynxEnabled, isReady } = useEmployerFeatureFlag(
    'lynx_payments_enabled',
    employerId
  );

  return {
    isLynxEnabled,
    isReady,
    paymentsProvider: isReady
      ? isLynxEnabled
        ? PaymentsProvider.LYNX
        : PaymentsProvider.ECHO
      : undefined,
  };
}
